import { getPointsRemainingByUnitData } from "../../api/dashboard-pointsRemaining";

const pointsRemainingByUnitData = {
  namespaced: true,
  state: () => ({
    pointsRemainingByUnitList: [],
    totalPointsRemaining: 0,
    totalDollars: 0,
    totalPercent: 0,
  }),

  getters: {
    getPointsRemainingByUnitList: (state) => {
      return state.pointsRemainingByUnitList;
    },
    getTotalPointsRemaining: (state) => {
      return state.totalPointsRemaining;
    },
    getTotalDollars: (state) => {
      return state.totalDollars;
    },
    getTotalPercent: (state) => {
      return state.totalPercent;
    },
  },

  actions: {
    fetchGetPointsRemainingByUnitData({ commit }) {
      return new Promise((resolve, reject) => {
        console.log("hello from dashboard fetch");
        getPointsRemainingByUnitData()
          .then((api_data) => {
            console.log(api_data);
            commit("SET_UNIT_LIST", api_data.pointsRemainingByUnitList);
            commit("SET_TOTAL_POINTS", api_data.pointsTotal);
            commit("SET_TOTAL_DOLLARS", api_data.dollarsTotal);
            commit("SET_TOTAL_PERCENT", api_data.percentageTotal);
          })
          .catch(() => {
            console.log("error from fetchGetPointsRemainingByUnitData store");
          });
      });
    },
  },

  mutations: {
    SET_UNIT_LIST: (state, unitList) => {
      state.pointsRemainingByUnitList = unitList ? unitList : [];
    },
    SET_TOTAL_POINTS: (state, totalPoints) => {
      state.totalPointsRemaining = totalPoints ? totalPoints : 0;
    },
    SET_TOTAL_DOLLARS: (state, totalDollars) => {
      state.totalDollars = totalDollars ? totalDollars : 0;
    },
    SET_TOTAL_PERCENT: (state, totalPercent) => {
      state.totalPercent = totalPercent ? totalPercent : 100;
    },
  },
};

export default pointsRemainingByUnitData;
